import React from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectIsLebtItemPoliciesEnabled } from 'businessTraveller/selectors/itemPolicy/selectIsLebtItemPoliciesEnabled'
import BusinessTravellerOfferCreditsTextLink from './BusinessTravellerOfferCreditsTextLink'
import BusinessTravellerItemPolicyOfferCreditsTextLink from './BusinessTravellerItemPolicyOfferCreditsTextLink'

type SupportedOffer =
  App.Offer |
  App.OfferSummary |
  App.BedbankOffer |
  App.BedbankOfferSummary

type Props = {
  numberOfNights?: number
  offer: SupportedOffer
  totalCost: number
  type: 'exact' | 'estimate'
  roomCount?: number
}

// Temporary switch while legacy and item-policy hotel offer credits run side by side behind lebt_item_policies_enabled.
function BusinessTravellerOfferCreditsTextLinkSwitch(props: Props) {
  const isItemPoliciesEnabled = useAppSelector(selectIsLebtItemPoliciesEnabled)

  if (isItemPoliciesEnabled) {
    return <BusinessTravellerItemPolicyOfferCreditsTextLink {...props} />
  }

  return <BusinessTravellerOfferCreditsTextLink {...props} />
}

export default BusinessTravellerOfferCreditsTextLinkSwitch
